import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TogglerComponent } from './toggler.component';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
    ],
    declarations: [
        TogglerComponent,
    ],
    exports: [
        TogglerComponent,
    ],
})

export class TogglerModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            TogglerComponent,
        ]);
    }
}
